module.exports = __webpack_public_path__ + "assets/logo-large.a640d6fd.svg";